<template>
  <div class="addAddition">
    <div class="card">
      <van-row class="header">
        <van-col span="16" class="header_name">产地附加费</van-col>
        <van-col span="8" class="header_right">
          <van-button
            icon="plus"
            class="add_btn_small"
            size="small"
            type="primary"
            plain
            @click="addAddition('place')"
          >添加</van-button>
        </van-col>
      </van-row>
      <div>
        <div class="addition_box" v-for="(kitem,ki) in addition.place" :key="ki">
          <van-row class="addition_line">
            <van-col span="4" class="addition_left">名称</van-col>
            <van-col span="20" class="addition_right">
              <input type="text" v-model="kitem.name" style="width: 100%;"  placeholder="请输入10位以内的附加费名称" />
            </van-col>
          </van-row>
          <van-row class="addition_line">
            <van-col span="4" class="addition_left">价格</van-col>
            <van-col span="20" class="addition_right">
              <KeyBoardInput
                :k_default_show="false"
                :k_isValueZero="false"
                v-model="kitem.price"
                :k_decimal="2"
              >
                <template slot="input_right">元</template>
              </KeyBoardInput>
            </van-col>
          </van-row>
          <div style="text-align:right;padding-bottom:0.2rem">
            <van-button class="add_btn_del" type="primary" plain @click="delAddition('place',ki)">删除</van-button>
          </div>
        </div>
      </div>
      <div class="addition_empty" v-if="!addition.place.length">暂无数据</div>
    </div>
    <div class="card">
      <van-row class="header">
        <van-col span="16" class="header_name">市场附加费</van-col>
        <van-col span="8" class="header_right">
          <van-button
            icon="plus"
            class="add_btn_small"
            size="small"
            type="primary"
            plain
            @click="addAddition('market')"
          >添加</van-button>
        </van-col>
      </van-row>
      <div>
        <div class="addition_box" v-for="(kitem,ki) in addition.market" :key="ki">
          <van-row class="addition_line">
            <van-col span="4" class="addition_left">名称</van-col>
            <van-col span="20" class="addition_right">
              <input type="text" v-model="kitem.name" placeholder="请输入10位以内的附加费名称" style="width: 100%;" />
            </van-col>
          </van-row>
          <van-row class="addition_line">
            <van-col span="4" class="addition_left">价格</van-col>
            <van-col span="20" class="addition_right">
              <KeyBoardInput
                :k_default_show="false"
                :k_isValueZero="false"
                v-model="kitem.price"
                :k_decimal="2"
              >
                <template slot="input_right">元</template>
              </KeyBoardInput>
            </van-col>
          </van-row>
          <div style="text-align:right;padding-bottom:0.2rem">
            <van-button
              class="add_btn_del"
              type="primary"
              plain
              @click="delAddition('market',ki)"
            >删除</van-button>
          </div>
        </div>
      </div>
      <div class="addition_empty" v-if="!addition.market.length">暂无数据</div>
    </div>
    <div class="confirm_btn" color="#31B158" @click="toAddStock">保存</div>
  </div>
</template>

<script>
import KeyBoardInput from "@/components/KeyBoardInput";
export default {
  name: "addAddition",
  components: {
    KeyBoardInput
  },
  data() {
    return {
      addition: {
        market: [],
        place: []
      }
    };
  },
  created() {
    if (this.$route.meta.backData) {
      delete this.$route.meta.backData;
    }
    if (this.$route.query.surcharge) {
      this.addition = JSON.parse(this.$route.query.surcharge);
    }
  },
  mounted() {},
  methods: {
    toAddStock() {
      let arr = JSON.parse(JSON.stringify(this.addition.place));
      for (let i = 0; i < arr.length; i++) {
        if (
          (!arr[i].name.trim() && arr[i].price.trim()) ||
          (arr[i].name.trim() && !arr[i].price.trim())
        ) {
          this.$toast("请完善产地附加费!");
          return false;
        } else if (!arr[i].name.trim() && !arr[i].price.trim()) {
          
          arr.splice(i,1);
          i--
        }else if(arr[i].name.length>10){
          this.$toast("请精简产地附加费名称!");
          return false;
        }
      }
      let arr1 = JSON.parse(JSON.stringify(this.addition.market));
      for (let i = 0; i < arr1.length; i++) {
        if (
          (!arr1[i].name.trim() && arr1[i].price.trim()) ||
          (arr1[i].name.trim() && !arr1[i].price.trim())
        ) {
          this.$toast("请完善市场附加费!");
          return false;
        } else if (!arr1[i].name.trim() && !arr1[i].price.trim()) {
          
          arr1.splice(i,1);
          i--
        }else if(arr1[i].name.length>10){
          this.$toast("请精简市场附加费名称!");
          return false;
        }
      }
      this.$route.meta.backData = JSON.stringify({ market: arr1, place: arr });
      this.$router.go(-1);
    },
    addAddition(type) {
      this.addition[type].push({
        name: "",
        price: "",
        type: type == "market" ? 2 : 1
      });
    },
    delAddition(type, i) {
      this.$dialog
        .confirm({
          title: "删除附加费",
          message: `确定删除${type === "market" ? "市场" : "产地"}${
            this.addition[type][i].name
          }附加费吗?`
        })
        .then(() => {
          let arr = this.addition[type].slice();
          arr.splice(i, 1);
          this.addition[type] = arr;
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>

<style lang="less" scoped>
.addAddition {
  position: relative;
  padding-bottom: 1.5rem;
  .card {
    width: 6.9rem;
    margin: 0.2rem auto;
    background: rgba(255, 255, 255, 1);
    border-radius: 0.1rem;
    background: #fff;
    padding: 0.3rem 0.19rem 0.3rem 0.2rem;
    box-sizing: border-box;
    .header {
      font-size: 0.32rem;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      padding-bottom: 0.26rem;
      border-bottom: #cccccc 1px solid;
      .header_name {
        text-align: left;
      }
      .header_right {
        text-align: right;
        .add_btn_small {
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(49, 177, 88, 1);
          border-radius: 0.06rem;
        }
      }
    }
    .addition_empty {
      font-size: 0.38rem;
      text-align: center;
      font-weight: 500;
      color: rgba(153, 153, 153, 1);
      line-height: 0.8rem;
      letter-spacing: 0.1rem;
    }
    .addition_box {
      margin-left: 0.5rem;
      border-top: 1px solid rgba(204, 204, 204, 1);
      &:nth-child(1) {
        border-top: none;
      }
    }

    .add_btn_del {
      height: 0.5rem;
      background: rgba(251, 83, 83, 1);
      border: 1px solid rgba(251, 83, 83, 1);
      border-radius: 0.04rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
    .addition_line {
      margin: 0.2rem 0;
      .addition_left {
        font-size: 0.32rem;
        line-height: 0.7rem;
      }
      .addition_right {
        display: flex;
        align-items: center;
        height: 0.7rem;
        input {
          width: 100%;
          text-align: right;
          background-color: transparent;
        }
        border: 1px solid #cccccc;
        padding: 0 0.1rem;
        font-size: 0.32rem;
        line-height: 0.5rem;
      }
    }
  }

  .confirm_btn {
    height: 0.88rem;
    background: rgba(49, 177, 88, 1);
    border-radius: 0.1rem;
    width: 6.9rem;
    text-align: center;
    line-height: 0.88rem;
    margin: 0.5rem auto;
    font-size: 0.36rem;
    color: #fff;
    letter-spacing: 0.1rem;
  }
}
// .addAddition {

//   position: relative;
//   min-height: calc(100vh - 0.88rem);
//   background-color: #fff;
//   padding: 0 0.3rem 0.3rem;
//   box-sizing: border-box;
//   & > div {
//     overflow: hidden;
//   }
//   .good_label {
//     font-size: 0.34rem;
//     color: #333;
//     line-height: 0.6rem;
//     span {
//       font-size: 0.28rem;
//       color: #fb5353;
//     }
//   }
//   .goods_btn {
//     padding-bottom: 0.15rem;
//     border-bottom: 0.01rem solid #e6e6e6;
//     margin-bottom: 0.15rem;
//     .goods_btns {
//       margin-top: 0.1rem;
//       display: flex;
//       align-items: center;
//       justify-content: flex-start;
//       flex-wrap: wrap;
//       span {
//         display: flex;
//         align-items: center;
//         height: 0.6rem;
//         padding: 0 0.4rem;
//         background-color: #e6e6e6;
//         border-radius: 0.3rem;
//         text-align: center;
//         margin-right: 0.2rem;
//         color: #999;
//         letter-spacing: 0.05rem;
//         margin-bottom: 0.1rem;
//         &.active {
//           background: rgba(49, 177, 88, 0.2);
//           color: #31b158;
//         }
//       }
//     }
//   }
//   .goods_batch_other {
//     border-bottom: 0.01rem solid #e6e6e6;
//     padding-bottom: 0.18rem;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     .good_sel {
//       font-size: 0.32rem;
//     }
//   }
//   .goods_batch_type {
//     padding-top: 0.18rem;
//     margin-bottom: 0.18rem;
//     .good_cli {
//       font-size: 0.32rem;
//       color: #999999;
//       .van-icon-arrow {
//         vertical-align: text-bottom;
//       }
//     }
//   }
//   .goods_input {
//     padding-bottom: 0.2rem;
//     .good_input2 {
//       border: 0.01rem solid #ccc;
//       overflow: hidden;
//       border-radius: 0.1rem;
//       background-color: #f5f5f5;
//       display: flex;
//       padding-right: 0.15rem;
//       justify-content: flex-end;
//     }
//     .good_input {
//       position: relative;
//       box-sizing: border-box;
//       height: 0.82rem;
//       background-color: #f5f5f5;
//       border: 0.01rem solid #ccc;
//       border-radius: 0.1rem;
//       display: flex;
//       align-items: center;
//       justify-content: space-between;
//       input {
//         width: 70%;
//         line-height: 0.8rem;
//         font-size: 0.34rem;
//         text-indent: 0.2rem;
//         border-radius: 0.1rem;
//         background-color: #f5f5f5;
//         box-sizing: border-box;
//       }
//       span {
//         line-height: 0.8rem;
//         padding-right: 0.2rem;
//       }
//     }
//   }
//   .good_save {
//     background-color: #31b158;
//     text-align: center;
//     line-height: 0.8rem;
//     margin-top: 0.5rem;
//     font-size: 0.36rem;
//     color: #fff;
//     letter-spacing: 0.1rem;
//     border-radius: 0.1rem;
//     &[disabled] {
//       background-color: #b3b3b3;
//     }
//   }
// }
</style>